import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import LoadingOverlay from "../components/LoadingOverlay";
interface Props {
  children: JSX.Element;
}

const RequireTfAdmin: React.FC<Props> = ({ children }) => {
  const { authUser, isFetchingUser } = useUser();
  const location = useLocation();

  // ユーザーデータ取得中の場合
  if (isFetchingUser) {
    return <LoadingOverlay />; // 画面全体にローディングオーバーレイを表示
  }

  // 権限チェック
  if (!authUser || !authUser.isTfAdmin) {
    return <Navigate to="/404" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireTfAdmin;
